/* FAIRY SWIRL — interactions */
(function () {
  'use strict';

  /* ---------- sparkles ---------- */
  function sparkles(root) {
    (root || document).querySelectorAll('.fs-sparkles:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var n = parseInt(el.getAttribute('data-count') || '18', 10);
      for (var i = 0; i < n; i++) {
        var s = document.createElement('i');
        s.style.left = Math.random() * 100 + '%';
        s.style.top = Math.random() * 100 + '%';
        s.style.animationDelay = (Math.random() * 3.2).toFixed(2) + 's';
        s.style.animationDuration = (2.4 + Math.random() * 2.4).toFixed(2) + 's';
        el.appendChild(s);
      }
    });
  }

  /* ---------- reveal + counters ---------- */
  function countUp(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1600, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = (target * eased).toFixed(decimals);
      el.textContent = prefix + Number(val).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      e.target.querySelectorAll('[data-count-to]').forEach(countUp);
      if (e.target.hasAttribute('data-count-to')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.15 }) : null;

  function reveal(root) {
    (root || document).querySelectorAll('.fs-reveal, [data-count-to]').forEach(function (el) {
      if (io) io.observe(el); else { el.classList.add('is-in'); if (el.hasAttribute('data-count-to')) countUp(el); }
    });
  }

  /* ---------- FAQ ---------- */
  function faq(root) {
    (root || document).querySelectorAll('.fs-faq__item:not([data-ready])').forEach(function (item) {
      item.setAttribute('data-ready', '1');
      var q = item.querySelector('.fs-faq__q');
      var a = item.querySelector('.fs-faq__a');
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- delivery date ---------- */
  function deliveryDates(root) {
    (root || document).querySelectorAll('[data-fs-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '7', 10);
      var max = parseInt(el.getAttribute('data-max') || '12', 10);
      function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
      var fmt = { month: 'short', day: 'numeric' };
      var now = new Date();
      el.textContent = addBiz(now, min).toLocaleDateString('en-US', fmt) + ' – ' + addBiz(now, max).toLocaleDateString('en-US', fmt);
    });
  }

  /* ---------- money ---------- */
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = whole + '.' + parts[1];
    if (!format) return '$' + amount;
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  /* ---------- PRODUCT BUY BOX ---------- */
  function buyBox(root) {
    (root || document).querySelectorAll('[data-fs-pdp]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      var dataEl = box.querySelector('[data-fs-product-json]');
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var moneyFormat = box.getAttribute('data-money-format');
      var colorIdx = parseInt(box.getAttribute('data-color-index'), 10);
      var packIdx = parseInt(box.getAttribute('data-pack-index'), 10);
      var selected = (product.selected || product.variants[0].options).slice();
      var idInput = box.querySelector('[data-fs-variant-id]');
      var atc = box.querySelectorAll('[data-fs-atc]');
      var slides = box.querySelectorAll('.fs-pdp__slide');
      var thumbs = box.querySelectorAll('.fs-pdp__thumb');
      var current = 0;
      var sticky = document.querySelector('[data-fs-sticky="' + box.id + '"]');

      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
        var t = thumbs[current]; if (t && t.scrollIntoView) t.parentNode.scrollLeft = t.offsetLeft - 40;
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = box.querySelector('.fs-pdp__arrow--prev'), next = box.querySelector('.fs-pdp__arrow--next');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      // swipe
      var stage = box.querySelector('.fs-pdp__stage'), x0 = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1)); x0 = null; });
      }

      function find(opts) {
        return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }

      function update(jump) {
        var v = find(selected);
        // swatch + pack states
        box.querySelectorAll('[data-fs-opt]').forEach(function (b) {
          var i = parseInt(b.getAttribute('data-fs-opt'), 10);
          b.classList.toggle('is-active', selected[i] === b.getAttribute('data-value'));
          b.setAttribute('aria-pressed', selected[i] === b.getAttribute('data-value') ? 'true' : 'false');
        });
        box.querySelectorAll('[data-fs-opt-label]').forEach(function (l) {
          l.textContent = selected[parseInt(l.getAttribute('data-fs-opt-label'), 10)];
        });
        // pack prices follow chosen color
        if (!isNaN(packIdx)) {
          box.querySelectorAll('.fs-pack').forEach(function (card) {
            var opts = selected.slice(); opts[packIdx] = card.getAttribute('data-value');
            var pv = find(opts); if (!pv) return;
            var n = card.querySelector('.fs-pack__now'), w = card.querySelector('.fs-pack__was');
            if (n) n.textContent = money(pv.price, moneyFormat);
            if (w) { w.textContent = pv.compare_at_price > pv.price ? money(pv.compare_at_price, moneyFormat) : ''; }
            var each = card.querySelector('[data-each]');
            var qty = parseInt(card.getAttribute('data-qty') || '1', 10);
            if (each && qty > 1) each.textContent = money(Math.round(pv.price / qty), moneyFormat) + ' each';
            var sv = card.querySelector('[data-save]');
            if (sv) sv.textContent = pv.compare_at_price > pv.price ? 'Save ' + money(pv.compare_at_price - pv.price, moneyFormat) : '';
          });
        }
        if (!v) {
          atc.forEach(function (b) { b.disabled = true; b.querySelector('[data-label]').textContent = 'Unavailable'; });
          return;
        }
        idInput.value = v.id;
        var now = money(v.price, moneyFormat);
        var was = v.compare_at_price > v.price ? money(v.compare_at_price, moneyFormat) : '';
        box.querySelectorAll('[data-fs-price]').forEach(function (e) { e.textContent = now; });
        box.querySelectorAll('[data-fs-compare]').forEach(function (e) { e.textContent = was; e.style.display = was ? '' : 'none'; });
        box.querySelectorAll('[data-fs-save]').forEach(function (e) {
          if (was) { var pct = Math.round((1 - v.price / v.compare_at_price) * 100); e.textContent = 'SAVE ' + pct + '%'; e.style.display = ''; }
          else e.style.display = 'none';
        });
        atc.forEach(function (b) {
          b.disabled = !v.available;
          b.querySelector('[data-label]').textContent = v.available ? b.getAttribute('data-text') : 'Sold out';
        });
        if (sticky) {
          var sp = sticky.querySelector('[data-fs-sticky-price]');
          if (sp) sp.innerHTML = now + (was ? ' <s>' + was + '</s>' : '');
        }
        if (jump && v.featured_media_id) {
          slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') == v.featured_media_id) show(k); });
        }
        if (box.hasAttribute('data-update-url') && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      box.querySelectorAll('[data-fs-opt]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var i = parseInt(b.getAttribute('data-fs-opt'), 10);
          selected[i] = b.getAttribute('data-value');
          update(i === colorIdx);
        });
      });

      function addToCart(btn) {
        var form = box.querySelector('form[data-fs-form]');
        var err = box.querySelector('.fs-pdp__error');
        if (err) err.style.display = 'none';
        btn.classList.add('is-loading');
        var label = btn.querySelector('[data-label]'); var old = label.textContent; label.textContent = 'Adding magic…';
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var fd = new FormData(form);
        if (cart && cart.getSectionsToRender) {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) cart.setActiveElement(btn);
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (err) { err.textContent = res.description || res.message || 'Something went wrong.'; err.style.display = 'block'; } return; }
          if (cart && cart.renderContents && res.sections) {
            cart.renderContents(res);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        }).catch(function () { form.submit(); })
          .finally(function () { btn.classList.remove('is-loading'); label.textContent = old; });
      }
      atc.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); }); });

      // sticky bar
      if (sticky) {
        var main = box.querySelector('.fs-pdp__info [data-fs-atc]');
        var sIO = new IntersectionObserver(function (en) {
          en.forEach(function (x) { sticky.classList.toggle('is-show', !x.isIntersecting && x.boundingClientRect.top < 0); });
        });
        if (main) sIO.observe(main);
        var sBtn = sticky.querySelector('[data-fs-sticky-btn]');
        if (sBtn) sBtn.addEventListener('click', function (e) { e.preventDefault(); var m = box.querySelector('.fs-pdp__info [data-fs-atc]'); if (m) addToCart(m); });
      }

      update(false);
    });
  }

  function init(root) { sparkles(root); reveal(root); faq(root); deliveryDates(root); buyBox(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
